import {
  UploadNotificationLocalStorageKeys,
  UploadNotificationSound,
  UploadNotificationState,
} from '@wetransfer/transfer/modules/upload-notifications/upload-notifications';

const getSafeInitialValue = (key: string, defaultValue: string) =>
  typeof localStorage === 'undefined'
    ? defaultValue
    : localStorage?.getItem?.(key) || defaultValue;

const initialState: UploadNotificationState = {
  active:
    getSafeInitialValue(UploadNotificationLocalStorageKeys.ACTIVE, 'false') ===
    'true',
  sound: getSafeInitialValue(
    UploadNotificationLocalStorageKeys.SOUND,
    'default'
  ) as UploadNotificationSound,
};

export default initialState;
